import { render, staticRenderFns } from "./PageAdmin.vue?vue&type=template&id=50cca544&"
import script from "./PageAdmin.vue?vue&type=script&lang=js&"
export * from "./PageAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports